import { render, staticRenderFns } from "./PublishNews.vue?vue&type=template&id=6b42dbbc&scoped=true"
import script from "./PublishNews.vue?vue&type=script&lang=js"
export * from "./PublishNews.vue?vue&type=script&lang=js"
import style0 from "./PublishNews.vue?vue&type=style&index=0&id=6b42dbbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42dbbc",
  null
  
)

export default component.exports